export default {
  Voucher: axios.create({
      baseURL: process.env.VUE_APP_ENDPOINT_API + "vounchers"
    })
  }


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/Voucher.js
// module id = Pfyc
// module chunks = 32